import React, { useState } from "react";
import { FaTicketAlt } from "react-icons/fa";
import ReferenceVoucherRecords from "./ReferenceVoucherRecords";
import ReferenceRewardPopup from "../../component/ReferenceRewardPopup";
import ReferenceInviteBonusPopup from "../../component/ReferenceInviteBonusPopup";
import UnavailableFeatureDialog from "../../component/UnavailableFeatureDialog";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { toFixedWithoutRounding } from "../../Utils/Toast";

const RewardCenter = () => {
  const [rewardFlow, setRewardFlow] = useState(null);
  const [treasureOpen, setTreasureOpen] = useState(false);
  const [feature, setFeature] = useState(null);
  const [recordsOpen, setRecordsOpen] = useState(false);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  return (
    <div id="mc_container" className="reward-center EN" onClick={(event) => { const control = event.target.closest(".button, #reward_records, .edit-icon, .copy-icon, #js_brush_balance"); if (control) { if (control.id === "reward_records") setRecordsOpen(true); else if (control.textContent.trim() === "Receive") { const type = control.closest(".reward-item")?.dataset.rewardFlow; if (type === "treasure") setTreasureOpen(true); else setRewardFlow(type === "wheel" ? 1 : 0); } else setFeature(control.textContent.trim() || "Reward Center"); } }}>
      {rewardFlow !== null && <ReferenceRewardPopup initialTab={rewardFlow} onClose={(reason) => { setRewardFlow(null); if (reason !== "deposit") setTreasureOpen(true); }} />}
      {treasureOpen && <ReferenceInviteBonusPopup onClose={() => setTreasureOpen(false)} />}
      {recordsOpen && <ReferenceVoucherRecords onClose={() => setRecordsOpen(false)} onUnavailable={setFeature} />}
      {feature && <UnavailableFeatureDialog feature={feature} onClose={() => setFeature(null)} />}
      <div className="sign-in-left-warp">
        <div className="sign-in-left clear-float">
          <div className="information-warp">
            <div className="upper-right" id="js_brush_balance">
              <i className="mcac-icon icon-brush" />
            </div>
            <div className="information-top" id="js_information_top">
              <div
                className="first-name"
                style={{
                  "background-image":
                    'url("/assets/Icon/0.webp")',
                }}
              />
              <div className="info-right">
                <div className="nickname-wrap">
                  <label
                    id="js_nickname"
                    className="ellipsis information-nickname"
                  >
                    {user?.user?.username}
                  </label>
                  <div className="edit-icon" />
                </div>
                <div className="copy-wrap">
                  <div className="copy-title" translate="user_name">
                    Username
                  </div>
                  <div className="copy-btn">
                    <label id="js_username_copy" className="username-copy">
                      {user?.user?.username}
                    </label>
                    <div className="copy-icon" />
                  </div>
                </div>
              </div>
            </div>
            <div className="information-money">
              <div className="template-new-info hide">
                <div className="total-wrapper">
                  <div className="total-item bonus">
                    <div className="item-title" translate="labell_totalBonus">
                      Total Bonus received
                    </div>
                    <div id="js_totalBonus" className="item-num" />
                  </div>
                  <div className="total-item points">
                    <div className="item-title" translate="label_totalPoints">
                      Total Points
                    </div>
                    <div id="js_totalPoints" className="item-num" />
                  </div>
                </div>
                <div className="today-info hide">
                  <div
                    className="info-title"
                    translate="label_dailyReceivedBonus"
                  >
                    Today's bonus
                  </div>
                  <div id="js_dailyReceivedBonus" className="info-num" />
                </div>
              </div>
              <div className="template-default-info">
                <div className="tips-text" translate="label_account_totalMoney">
                  Available Balance
                </div>
                <div
                  className="money-view font-arial more-money"
                  id="js_balance"
                >
                  ৳ {Number(userCoins?.balance || 0).toFixed(2).split(".")[0]}.<small>{Number(userCoins?.balance || 0).toFixed(2).split(".")[1]}</small>
                </div>
                <div
                  className="js-point hide"
                  translate="label_integral_current"
                >
                  Current points
                </div>
                <div
                  className="font-arial cuurent-integral js-point hide"
                  id="js_PointBalance"
                >
                  0
                </div>
                <div className="clear-float hide">
                  <div className="integral-item">
                    <div translate="label_integral_month">
                      This month's points
                    </div>
                    <div className="font-arial">0</div>
                  </div>
                  <div className="integral-item">
                    <div translate="label_integral_Omission">
                      Missing points
                    </div>
                    <div className="font-arial">0</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="integral-task-list ps"
            id="task_list"
            style={{ position: "relative", overflow: "hidden" }}
          >
            <div className="integral-task hide" id="js_nav_newbie">
              <div className="task-img icon-noob-task">
                <div className="count hide" />
              </div>
              <div className="task-view">
                <div className="task-title" translate="label_task_noob">
                  Beginner Task
                </div>
                <div
                  className="task-watch js_newbie_watch"
                  translate="label_task_ongoing"
                >
                  A task is in progress
                </div>
              </div>
              <div
                className="button btn-cancel btn-check js_check"
                translate="button_see"
              >
                View
              </div>
            </div>
            <div className="integral-task" id="js_temu">
              <div className="task-img icon-temu">
                <div className="count hide" />
              </div>
              <div className="task-view">
                <div className="task-title" translate="label_temu">
                  Temu Coupon
                </div>
                <div className="task-watch" translate="button_see">
                  View
                </div>
              </div>
              <div
                className="button btn-cancel btn-check js_check js_promo_check"
                translate="button_see"
              >
                View
              </div>
            </div>
            <div className="integral-task" id="js_sign_task">
              <div
                className="task-img icon-sign-task js_check"
                data-configid={0}
              >
              </div>
              <div className="task-view">
                <div className="task-title" translate="label_task_sign">
                  Sign-in task
                </div>
                <div className="task-watch" translate="label_task_ongoing">
                  A task is in progress
                </div>
              </div>
              <div
                className="button btn-cancel btn-check js_check"
                data-configid={0}
                translate="button_see"
              >
                View
              </div>
            </div>
            <div className="integral-task hide" id="js_point_mall">
              <div className="task-img icon-integral-mall disable" />
              <div className="task-view">
                <div className="task-title" translate="label_integral_mall">
                  Points mall
                </div>
                <div className="task-watch" translate="info_msg_open_await">
                  No messages, stay tuned.
                </div>
              </div>
            </div>
            <div className="integral-task hide" id="js_rescue_fund">
              <div className="task-img icon-rescue-fund">
                <div className="count hide" />
              </div>
              <div className="task-view">
                <div className="task-title" translate="label_rescue_fund">
                  Rescue fund
                </div>
                <div className="task-watch" translate="label_rescue_tip">
                  Help to reborn
                </div>
              </div>
              <div
                className="button btn-cancel btn-check js_check js_rescue_check"
                translate="button_see"
              >
                View
              </div>
            </div>
            <div className="integral-task" id="js_promo_code">
              <div className="task-img icon-promo-code">
                <div className="count hide" />
              </div>
              <div className="task-view">
                <div className="task-title" translate="label_promo_code">
                  Promo Code
                </div>
                <div className="task-watch" translate="label_promo_code_tip">
                  Go
                </div>
              </div>
              <div
                className="button btn-cancel btn-check js_check js_promo_check"
                translate="button_see"
              >
                View
              </div>
            </div>
            <div className="integral-task hide" id="js_luckyBet">
              <div className="task-img icon-luckyBet">
                <div className="count hide" />
              </div>
              <div className="task-view">
                <div className="task-title" translate="label_luckyBet">
                  Lucky Bet
                </div>
                <div className="task-watch" translate="label_click_to_go">
                  Go
                </div>
              </div>
              <div
                className="button btn-cancel btn-check js_check js_luckyBet_check"
                translate="button_see"
              >
                View
              </div>
            </div>
            <div className="ps__rail-x" style={{ left: "0px", bottom: "0px" }}>
              <div
                className="ps__thumb-x"
                tabIndex={0}
                style={{ left: "0px", width: "0px" }}
              />
            </div>
            <div className="ps__rail-y" style={{ top: "0px", right: "0px" }}>
              <div
                className="ps__thumb-y"
                tabIndex={0}
                style={{ top: "0px", height: "0px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="luckyBet-wrapper" id="js_luckyBet_list">
        <div className="model-case all-h luckyBet-model">
          <div className="model-mask" />
          <div className="model-content clear-float">
            <div className="close-info js_close" />
            <div className="luckyBet-wrap">
              <div className="luckyBet-list-wrap">
                <div className="luckyBet-img" />
                <div className="luckyBet-list" />
              </div>
              <div className="luckyBet-detail-wrap">
                <div className="luckyBet-detail-item reward-bet">
                  <div
                    className="luckyBet-detail-title"
                    translate="label_reward_bet_order"
                  >
                    Reward Bet
                  </div>
                  <div className="luckyBet-detail-table" />
                  <div className="pagination-wrap js_pagination" />
                </div>
                <div className="luckyBet-detail-item claim-count">
                  <div
                    className="luckyBet-detail-title"
                    translate="label_claim_count"
                  >
                    Claim count
                  </div>
                  <div className="luckyBet-detail-table" />
                </div>
                <div className="luckyBet-detail-item reward-rules">
                  <div
                    className="luckyBet-detail-title"
                    translate="label_bet_reward_rules"
                  >
                    Bet Slip Reward Rule
                  </div>
                  <div className="luckyBet-detail-table" />
                </div>
                <div className="luckyBet-detail-item reward-description">
                  <div
                    className="luckyBet-detail-title"
                    translate="label_luckyBet_description"
                  >
                    Redemption Instructions
                  </div>
                  <div className="luckyBet-detail-desc" />
                </div>
                <div className="luckyBet-no-data hide" translate="result_null">
                  No matched data found
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="temu-history-wrapper" id="js_temu_list">
        <div className="model-case all-h temu-history-model">
          <div className="model-mask" />
          <div className="model-content clear-float">
            <div className="close-info js_close" />
            <div className="history-wrapper">
              <div className="history-top">
                <div className="history-img" />
                <div className="history-amount-wrap">
                  <div className="amount-title" translate="label_claimedAmount">
                    Total Claimed Amount
                  </div>
                  <div className="amount-num" />
                </div>
              </div>
              <div className="history-result" />
              <div className="pagination-wrap js_pagination" />
            </div>
          </div>
        </div>
      </div>
      <div className="temu-history-wrapper" id="js_temu_list">
        <div className="model-case all-h temu-history-model">
          <div className="model-mask" />
          <div className="model-content clear-float">
            <div className="close-info js_close" />
            <div className="history-wrapper">
              <div className="history-top">
                <div className="history-img" />
                <div className="history-amount-wrap">
                  <div className="amount-title" translate="label_claimedAmount">
                    Total Claimed Amount
                  </div>
                  <div className="amount-num" />
                </div>
              </div>
              <div className="history-result" />
              <div className="pagination-wrap js_pagination" />
            </div>
          </div>
        </div>
        <div className="sign-in-right clear-float" id="sign_in_right">
          <div className="reward-title" id="label_reward_menu">
            <span data-type="rewardVolume" className="active">
              <label translate="label_reward_center">Receive Center</label>
              <div className="count">3</div>
            </span>
            <div id="reward_records" translate="label_reward_records">
              <FaTicketAlt aria-hidden="true" /> Voucher records
            </div>
          </div>
          <div className="reward-list" id="reward_list">
            {[
              { type: "TEMU", flow: "treasure", title: "Temu Coupon", name: "বন্ধুদের আমন্ত্রণ জানান, ট্রেজার বক্স খুলে ৳৩৮৮...", days: 28, clock: "21:55:27", deadline: "2026-11-04" },
              { type: "LOGIN", flow: "eggs", title: "Smash & Win", name: "প্রতিদিন লগইন করে সোনার ডিম ভাঙুন।", days: 0, clock: "05:49:36", deadline: "2026-10-06" },
              { type: "RAFFLE", flow: "wheel", title: "Lucky Wheel", name: "অ্যাপটি ডাউনলোড করুন এবং পুরস্কার নিন।", days: 28, clock: "21:55:27", deadline: "2026-11-04" },
            ].map((voucher, index) => (
              <div key={voucher.type} className={`reward-item volume ${voucher.type}`} data-reward-flow={voucher.flow}>
                <div className="reward-main-content">
                  <div className="reward-number font-arial">{index + 1}</div>
                  <div className="reward-info"><div className="reward-name">{voucher.name}</div>{index === 0 && <button type="button" className="reference-voucher-description" onClick={() => setTreasureOpen(true)}>Description ⓘ</button>}</div>
                  <div className="reward-view">
                    <div className="reward-view-left"><div className="reward-text">Voucher</div><div className="txt-center"><strong className="font-arial">{voucher.title}</strong></div><div className="cut-off-day">Deadline: {voucher.deadline}</div></div>
                    <div className="reward-view-right"><div className="surplus-text">Remaining</div><div><strong className="font-arial">{voucher.days}</strong><strong>Day</strong></div><div className="clock-number">{voucher.clock}</div><button type="button" className="button button-receive js_volume">Receive</button></div>
                  </div>
                </div>
              </div>
            ))}
            <div className="reward-item .reward-no-data hide">
              <div className="reward-main-content">
                <div className="reward-info">
                  <div className="reward-name" translate="label_noyet_volume">
                    No ticket available
                  </div>
                  <div className="reward-content" />
                </div>
                <div className="reward-view">
                  <div className="reward-view-left">
                    <div
                      className="reward-text"
                      translate="label_reward_ticket"
                    >
                      Voucher
                    </div>
                    <div className="txt-center">
                      <strong className="font-arial">000</strong>
                    </div>
                    <div className="cut-off-day">
                      <label
                        className="colon"
                        translate="label_reward_deadline"
                      >
                        Deadline
                      </label>
                      ----.--.--
                    </div>
                  </div>
                  <div className="reward-view-right done-received">
                    <div
                      className="surplus-text"
                      translate="label_reward_remaining"
                    >
                      Remaining
                    </div>
                    <div>
                      <strong className="font-arial">00</strong>
                      <strong translate="label_day">Day</strong>
                    </div>
                    <div className="clock-number">—</div>
                    <div
                      className="button button-receive"
                      translate="button_receive"
                    >
                      Receive
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="model-case all-h" id="model_case">
          <div className="model-mask" />
          <div
            className="setting-modal model-content clear-float"
            id="model_content"
          >
            <div className="close-info" translate="label_close">
              Close
            </div>
            <div className="setting-nav hide" id="js_sign_nav" />
            <div className="setting-nav hide" id="js_newbie_nav" />
            <div className="sign-in-calendar hide" id="js_reward_calendar" />
            <div className="sign-in-calendar hide" id="js_calendar" />
            <div className="info-wrap setting-item hide" id="js_newbie_info">
              <div className="info-scroll js_info_scroll">
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="payeename"
                  data-required="payeenamerequired"
                >
                  <div className="icons-info icons-user" />
                  <div className="item-right">
                    <div className="item-text" translate="label_payee_name">
                      Full name
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to
                  data-value="withdrawalaccount"
                  data-required="withdrawalaccountrequired"
                >
                  <div className="icons-info icons-card" />
                  <div className="item-right">
                    <div className="item-text" translate="task_bind_card_label">
                      Bind withdrawal account
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="bankCards"
                  data-value="bankcard"
                  data-required="bankcardrequired"
                >
                  <div className="icons-info icons-card" />
                  <div className="item-right">
                    <div className="item-text" translate="task_bind_card_label">
                      Bind withdrawal account
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="virtualWallets"
                  data-value="virtualwallet"
                  data-required="virtualwalletrequired"
                >
                  <div className="icons-info icons-virtual" />
                  <div className="item-right">
                    <div
                      className="item-text"
                      translate="task_bind_virtual_label"
                    >
                      Bind Crypto Wallet
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="eWallet"
                  data-value="electronicwallet"
                  data-required="electronicwalletrequired"
                >
                  <div className="icons-info icons-electronic" />
                  <div className="item-right">
                    <div
                      className="item-text"
                      translate="task_bind_ewallet_label"
                    >
                      Bind E-wallet
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="mobile"
                  data-required="contactnumberrequired"
                >
                  <div className="icons-info icons-phone" />
                  <div className="item-right">
                    <div className="item-text" translate="label_phone_number">
                      Mobile number
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="mobileVerified"
                  data-value="mobileverified"
                  data-required="mobileverified"
                >
                  <div className="icons-info icons-phone" />
                  <div className="item-right">
                    <div className="item-text" translate="info_verify_mobile">
                      Verify mobile no.
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="qq"
                  data-required="qqrequired"
                >
                  <div className="icons-info icons-qq" />
                  <div className="item-right">
                    <div className="item-text">QQ</div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="email"
                  data-required="emailrequired"
                >
                  <div className="icons-info icons-email" />
                  <div className="item-right">
                    <div className="item-text" translate="label_email">
                      Email
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="zalo"
                  data-required="zalorequired"
                >
                  <div className="icons-info icons-zalo" />
                  <div className="item-right">
                    <div className="item-text" translate="label_zalo">
                      Zalo
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="line"
                  data-required="linerequired"
                >
                  <div className="icons-info icons-line" />
                  <div className="item-right">
                    <div className="item-text" translate="label_Line">
                      LINE
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="wechat"
                  data-required="wechatrequired"
                >
                  <div className="icons-info icons-wechat" />
                  <div className="item-right">
                    <div className="item-text" translate="label_wechat">
                      Wechat
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="facebook"
                  data-required="facebookrequired"
                >
                  <div className="icons-info icons-facebook" />
                  <div className="item-right">
                    <div className="item-text" translate="label_Facebook">
                      Facebook
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="address"
                  data-required="addressrequired"
                >
                  <div className="icons-info icons-address" />
                  <div className="item-right">
                    <div className="item-text" translate="label_address">
                      Current Address
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to
                  data-value="idpicture"
                  data-required="idrequired"
                >
                  <div className="icons-info icons-id" />
                  <div className="item-right">
                    <div className="item-text" translate="info_verify_id">
                      ID Verification
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to
                  data-value="kycVerified"
                  data-required="kycrequired"
                >
                  <div className="icons-info icons-id" />
                  <div className="item-right">
                    <div className="item-text" translate="identify_verify">
                      Identity Verification
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="viber"
                  data-required="viberrequired"
                >
                  <div className="icons-info icons-viber" />
                  <div className="item-right">
                    <div className="item-text" translate="label_viber">
                      Viber
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="birthday"
                  data-required="birthdayrequired"
                >
                  <div className="icons-info icons-birthday" />
                  <div className="item-right">
                    <div className="item-text" translate="birthday_date">
                      Birthday
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="twitter"
                  data-required="twitterrequired"
                >
                  <div className="icons-info icons-twitter" />
                  <div className="item-right">
                    <div className="item-text" translate="label_twitter">
                      Twitter
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="telegram"
                  data-required="telegramrequired"
                >
                  <div className="icons-info icons-telegram" />
                  <div className="item-right">
                    <div className="item-text" translate="label_telegram">
                      Telegram
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="profile"
                  data-value="whatsapp"
                  data-required="whatsapprequired"
                >
                  <div className="icons-info icons-whatsapp" />
                  <div className="item-right">
                    <div className="item-text" translate="label_Whatsapp">
                      Whatsapp
                    </div>
                    <div
                      className="item-detail"
                      translate="label_forward_security_center"
                    >
                      Move to security center
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
                <div
                  className="account-bind-item js_account_item red-incomplete clear-float"
                  data-to="depositv2"
                  data-value="promotionperioddepositamount"
                  data-required="promotionperioddepositamountrequired"
                >
                  <div className="icons-info icons-deposit" />
                  <div className="item-right">
                    <div className="item-text">
                      <span translate="label_deposit">Deposit</span>
                      <span className="item-count" />
                    </div>
                    <div className="item-detail" translate="label_go_deposit">
                      Proceed to deposit
                    </div>
                    <div
                      className="icons-status js_icons_status"
                      translate="label_incomplete"
                    >
                      Incomplete
                    </div>
                  </div>
                </div>
              </div>
              <div className="btn-wrap">
                <div className="btn-tips">
                  <span className="colon" translate="label_completed">
                    Complete
                  </span>
                  <span className="highlight-red">
                    <span className="js_completed_number">0</span>/
                    <span className="js_required_number">5</span>
                  </span>
                </div>
                <div
                  className="button btn-submit disabled btn-huge"
                  id="js_btn_get"
                  translate="label_click_to_get"
                >
                  Click to receive
                </div>
              </div>
            </div>
            <div
              className="rescue-fund-list setting-item hide"
              id="js_rescue_list"
            >
              <div className="list-item disabled-click hide js_no_data">
                <div className="item-icon" />
                <div className="item-account">000</div>
                <div className="item-btn" translate="button_receive">
                  Receive
                </div>
                <div className="item-text clear-float">
                  <div className="text-type">
                    <span translate="label_type">Types</span>： <span>--</span>
                  </div>
                  <div className="text-time">
                    <span translate="label_give_time">Claim time</span>：{" "}
                    <span>----.--.--</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="sign-in-rules  hide" id="js_reward_rules">
              <div className="sign-every-item">
                <div className="item-view">
                  <div className="item-text" translate="label_sign_days">
                    Last SignIn
                  </div>
                  <div
                    className="money-number font-arial"
                    data-key="dayCountClaimed"
                  >
                    0
                  </div>
                </div>
                <div className="item-view">
                  <div className="item-text" translate="label_sign_reward">
                    Sign-in total bonus
                  </div>
                  <div
                    className="money-number font-arial total-money"
                    data-key="totalClaimedAmount"
                  >
                    0
                  </div>
                </div>
                <div className="item-view total-integral hide">
                  <div className="item-text" translate="label_sign_integral">
                    Sign-in total points
                  </div>
                  <div
                    className="money-number font-arial total-integral"
                    data-key="totalClaimedPointAmount"
                  >
                    0
                  </div>
                </div>
              </div>
              <div className="promo-time">
                <label
                  htmlFor
                  className="colon"
                  translate="label_task_effective"
                >
                  Effective time of the task
                </label>
                <label htmlFor className="effective-time" data-key="noExpiry" />
              </div>
              <div className="sign-rules-view" id="sign_rules_view">
                <div className="rules-text" data-key="name" />
                <div className="rules-content" data-key="description" />
              </div>
            </div>
            <div className="sign-in-rules setting-item hide" id="js_rules">
              <div className="egg_title" translate="label_egg_title">
                GOLDEN EGGS
              </div>
              <div className="promo-time">
                <label
                  htmlFor
                  className="colon"
                  translate="label_task_effective"
                >
                  Effective time of the task
                </label>
                <label htmlFor className="effective-time" data-key="noExpiry" />
              </div>
            </div>
            <div
              className="promo-code-list setting-item hide"
              id="js_promo_list"
            >
              <div className="promo-left">
                <div className="code-title">
                  <span
                    className="ellipsis item-text"
                    translate="label_promo_code"
                  >
                    Promo Code
                  </span>
                </div>
                <div className="code-content">
                  <div className="input-top">
                    <input
                      type="text"
                      className="input-control code-input"
                      name="promoCode"
                      autoComplete="off"
                      translate="input_promo_code"
                      onkeyup="value=value.replace(/[\W]/g,'')"
                      placeholder="Fill in your promo code"
                    />
                    <div
                      className="code-btn disable"
                      translate="exchange_promo_code"
                    >
                      Redeem
                    </div>
                  </div>
                  <div className="error-tip" />
                </div>
                <div className="success-msg hide">
                  <div className="msg-top">
                    <div className="msg-icon" />
                    <div
                      className="msg-title"
                      translate="code_redemption_success"
                    >
                      Redeemed successfully
                    </div>
                  </div>
                  <div className="msg-bottom" />
                  <div className="success-msg-btn" translate="label_know">
                    Got it
                  </div>
                </div>
              </div>
              <div className="promo-right">
                <div className="promo-code-msg hide">
                  <div className="msg-content" />
                  <div className="msg-btn" translate="label_know">
                    Got it
                  </div>
                </div>
                <div className="promo-list-title" translate="promo_code_title">
                  Promo Code List
                </div>
                <div className="no-list">
                  <div
                    className="no-list-content"
                    translate="no_promo_code_list"
                  >
                    No promotion code is currently available.
                  </div>
                </div>
                <div className="promo-list-wrapper hide" />
              </div>
            </div>
          </div>
        </div>
        <div className="model-case all-h" id="model_case_records">
          <div className="model-mask" />
          <div
            className="setting-modal model-content clear-float"
            id="model_content"
          >
            <div className="reward-title">
              <span className="title-text">
                <label translate="label_reward_records">Voucher records</label>
              </span>
              <div className="search-form" id="ui-id-7">
                <div className="form-group ">
                  <input
                    id="today_record"
                    type="radio"
                    defaultChecked="checked"
                    defaultValue={0}
                    className="radio-control"
                    name="set_date"
                  />
                  <label htmlFor="today_record" className="radio-control-ie" />
                  <label htmlFor="today_record" translate="mc_today">
                    Today
                  </label>
                </div>
                <div className="form-group">
                  <input
                    id="yestaday_record"
                    type="radio"
                    defaultValue={1}
                    className="radio-control"
                    name="set_date"
                  />
                  <label
                    htmlFor="yestaday_record"
                    className="radio-control-ie"
                  />
                  <label htmlFor="yestaday_record">Yesterday</label>
                </div>
                <div className="form-group" style={{ display: "false" }}>
                  <input
                    type="radio"
                    defaultValue={6}
                    id="last_record"
                    className="radio-control"
                    name="set_date"
                  />
                  <label htmlFor="last_record" className="radio-control-ie" />
                  <label htmlFor="last_record" translate>
                    7-Days
                  </label>
                </div>
                <div className="form-group">
                  <input
                    id="datetime_range_picker"
                    type="radio"
                    defaultValue="custom"
                    className="radio-control"
                    name="set_date"
                  />
                  <label
                    htmlFor="datetime_range_picker"
                    className="radio-control-ie"
                  />
                  <input type="text" className="input-control date js_date" />
                </div>
                <div className="form-group v-line" />
                <div className="form-group">
                  <label
                    className="txt-label colon"
                    translate="label_ticket_type"
                  >
                    Ticket type
                  </label>
                  <div className="select-control js_type" />
                </div>
                <div className="form-group">
                  <div translate="button_search" className="button btn-submit">
                    Search
                  </div>
                </div>
                <div className="daterangepicker ltr auto-apply show-calendar opensright">
                  <div className="ranges" />
                  <div className="drp-calendar left">
                    <div className="calendar-table" />
                    <div
                      className="calendar-time"
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="drp-calendar right">
                    <div className="calendar-table" />
                    <div
                      className="calendar-time"
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="drp-buttons">
                    <span className="drp-selected" />
                    <button
                      className="cancelBtn btn btn-sm btn-default"
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className="applyBtn btn btn-sm btn-primary"
                      disabled="disabled"
                      type="button"
                    >
                      Apply
                    </button>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="close-info" translate="label_close">
              Close
            </div>
            <div className="reward-records-content">
              <div className="table-data data-col-9-logs  js_table">
                <div className="table-thead">
                  <div className="table-tr">
                    <div className="table-td" translate="label_ticket_name">
                      Ticket name
                    </div>
                    <div className="table-td" translate="label_ticket_type">
                      Ticket type
                    </div>
                    <div className="table-td" translate="label_ticket_time">
                      Used time
                    </div>
                    <div className="table-td" translate="label_product_name">
                      Product name
                    </div>
                    <div className="table-td" />
                    <div className="table-td" translate="reward_gift_code">
                      Redemption code
                    </div>
                    <div
                      className="table-td txt-right amount hide"
                      translate="label_bonus"
                    >
                      Bonus
                    </div>
                    <div
                      className="table-td txt-right point hide"
                      translate="label_integral"
                    >
                      Point
                    </div>
                  </div>
                </div>
                <div className="table-tbody" />
                <div className="table-footer">
                  <div className="table-tr">
                    <div className="table-td" />
                    <div className="table-td" />
                    <div className="table-td" />
                    <div className="table-td" />
                    <div className="table-td" />
                    <div className="table-td" />
                    <div
                      className="table-td total hide"
                      translate="label_total"
                    >
                      Total
                    </div>
                    <div
                      className="table-td js_bonus cl-win amount hide"
                      data-amount={0}
                    >
                      0.00
                    </div>
                    <div
                      className="table-td js_point cl-win point hide"
                      data-amount={0}
                    >
                      0.00
                    </div>
                  </div>
                </div>
                <div className="table-page">
                  <div className="pagination-wrap js_pagination" />
                </div>
              </div>
            </div>
            <div className="promo-records-list" id="js_reward_records_form" />
          </div>
        </div>
        <div className="condition-modal hide" id="model_condition">
          <div className="model-mask" />
          <div className="reward-condition">
            <div className="reward-condition-title" translate="label_msg_title">
              Please complete the following
            </div>
            <div className="condition-wrap" />
            <span className="reward-condition-btn" translate="label_know">
              Got it
            </span>
          </div>
        </div>
      </div>
      <div className="condition-modal hide" id="model_condition">
        <div className="model-mask" />
        <div className="reward-condition">
          <div className="reward-condition-title" translate="label_msg_title">
            Please complete the following
          </div>
          <div className="condition-wrap" />
          <span className="reward-condition-btn" translate="label_know">
            Got it
          </span>
        </div>
      </div>
    </div>
  );
};

export default RewardCenter;
